import React, { useEffect } from 'react';
import { Grid, Header, Icon, Container, Segment, Table } from 'semantic-ui-react'
import { changePageName, checkiscompanypay, getLimitUsersPackage } from '../../../../myfunctions';
import { useHistory } from "react-router-dom";

function StatueV2() {

  let history = useHistory();
  useEffect(() => {
    changePageName()
    return () => { }; // use effect cleanup to set flag false, if unmounted
  }, [])// eslint-disable-line react-hooks/exhaustive-deps

  function clickLink(link) {
    //addLinkToSitemap(link)
    history.push(link)

  }

  return (
    <Grid stackable >
      <Grid.Row >


        <Grid.Column width={16} >
          <Container textAlign='center' >

            <Header as='h1' textAlign='center'>
              <Icon name='mail' color="red" />
              <Header.Content>Regulamin</Header.Content>
            </Header>

            <Segment>
              <article className="Btext">
                Regulamin korzystania z aplikacji Generator Turniejów (turniej-generator.pl)
                <br />  <br />
                {checkiscompanypay() ? <> <Header as="h3">Właściciel Strony</Header>
                  Właścicielem Strony jest MBITLAB Mateusz Bodziony, Rydlówka 4/2, 30-363 Kraków, Polska, NIP 7343335376, zwana dalej Administratorem.
                  <br /> Możesz się z nami skontaktować wysyłając email na adres: biuro@turniej-generator.pl. lub skorzystać z formularza dostępnego w zakładce kontakt
                </> : ""}
                <Header as="h3">1. Postanowienia ogólne</Header>
                1.1. Niniejszy regulamin określa zasady korzystania z aplikacji internetowej Generator Turniejów (dalej: „Aplikacja”), dostępnej pod adresem turniej-generator.pl.
                <br />  1.2. Aplikacja jest gotowym oprogramowaniem, które umożliwia użytkownikom tworzenie i zarządzanie turniejami online.
                Aplikacja jest dostępna z poziomu dowolnej przeglądarki internetowej,
                bez konieczności instalowania dodatkowego oprogramowania.
                Do poprawnego działania wymagane jest korzystanie z aktualnej wersji przeglądarki internetowej,
                takiej jak Google Chrome, Mozilla Firefox, Opera, Microsoft Edge lub Safari.
                <br />  1.3. Administrator serwisu turniej-generator.pl może w dowolnym momencie zmieniać, modyfikować, aktualizować, dodawać lub usuwać fragmenty niniejszych Warunków. Prosimy o okresowe sprawdzanie niniejszych Warunków pod kątem zmian. Dalsze korzystanie z tej Witryny po opublikowaniu jakichkolwiek zmian będzie oznaczać akceptację tych zmian.
                <br />  1.4. Dążąc do ciągłego ulepszania tej Witryny i jej użyteczności, możemy dodawać dodatkowe usługi lub wprowadzać zmiany w istniejących usługach. W przypadku wprowadzenia takich zmian, niniejsze Warunki mają zastosowanie do nowych usług i wszelkich zmian w istniejących usługach.
                <br />  1.5. Korzystanie z aplikacji wymaga akceptacji niniejszego regulaminu.

                <Header as="h3">2.  Funkcje aplikacji</Header>
                2.1. Aplikacja umożliwia użytkownikom korzystanie z następujących funkcji:
                <br /> - Tworzenie turniejów/lig i zarządzanie nimi
                <br /> - Automatyczne generowanie drabinek turniejowych,tabel grupowych, harmonogramów ligowych oraz przypisanie uczestników
                <br />  - Monitorowanie wyników i postępów w turniejach
                <br />2.2. Aplikacja jest narzędziem w pełni zautomatyzowanym, działającym w modelu „gotowego oprogramowania”.
                <br />2.3. Administrator nie świadczy dodatkowych usług projektowych ani doradczych związanych z dostosowaniem aplikacji do indywidualnych potrzeb użytkowników.


                <Header as="h3">3. Warunki Użytkowania</Header>
                3.1. Aby korzystać z aplikacji, użytkownik musi utworzyć konto i zachować poufność swoich danych logowania.
                <br />3.2. Konto użytkownika jest przypisane do jednej osoby i nie może być udostępniane innym osobom.
                <br />3.3. Administrator zapewnia dostęp do aplikacji zgodnie z obowiązującymi standardami technologicznymi na poziomie 99.9% SLA, jednak nie ponosi odpowiedzialności za przerwy w dostępności wynikające z siły wyższej lub działań niezależnych od administratora.



                <Header as="h3">4. Rodzaje Pakietów i Płatności</Header>
                4.1. Korzystanie z podstawowej wersji aplikacji jest darmowe, jednak zaawansowane funkcjonalności mogą wymagać zakupu pakietów.
                <br />4.2. Dostępne pakiety:
                <br />
                <br />a. Pakiet Brązowy: darmowy, z ograniczeniami m.in. do {Number(process.env.REACT_APP_IN_LIMITBROWNCAT)} (kategorie) i limitu {getLimitUsersPackage(0)} uczestników per kategoria, 1 turniej per tydzień.
                <br />b. Pakiet Srebrny: kosztuje 1 token, ograniczeniami limit {getLimitUsersPackage(1)} uczestników per kategoria, {Number(process.env.REACT_APP_IN_LIMITSILVERCAT)} (kategorie), brak limitu ilości turniejów per dzien, obowiązuje limit opisany w punkcie 4.2a.
                <br />c. Pakiet Złoty: kosztuje 2 tokeny, bez limitów uczestników w kategorii oraz ilości kategorii, obowiązuje limit opisany w punkcie 4.2a.

                <br />d. Pakiet Diamentowy: miesięczna subskrypcja, zapewniająca pełny dostęp do systemu bez potrzeby zakupu tokenów. Subskrypcja nie odnawia się automatycznie, a użytkownik może ją przedłużyć w dowolnym momencie. Brak opłacenia subskrypcji skutkuje ograniczonym dostępem do aplikacji. obowiązuje limit opisany w punkcie 4.2a.
                <br /><br />{getLimitInfoStatue()}
                <br /><br />4.3. Tokeny są wyłącznie środkiem dostępu do funkcjonalności aplikacji, a nie odrębnym produktem, dostępne do zakupu za pośrednictwem systemu płatności,
                <br />4.4. Szczegółowe informacje o funkcjach systemu dla poszczególnych pakietów znajdują się w zakładce <span className='cursorPointer tllink' onClick={() => clickLink("/cennik")}>CENNIK</span>

                <Header as="h3">5. Doładowanie i Zarządzanie Tokenami</Header>
                5.1. Subskrypcja lub tokeny mogą być doładowywane poprzez system płatności dostępny w Aplikacji, za pomocą serwisu  {checkiscompanypay() ? "Przelewy24.pl" : "HotPay.pl"}.
                <br />5.2. Zakupione tokeny nie podlegają zwrotowi ani wymianie na walutę rzeczywistą. Tokeny nie wygasają, chyba że konto użytkownika zostanie usunięte.
                <br />5.3. W przypadku usunięcia konta przez użytkownika lub administratora, niewykorzystane tokeny przepadają.

                <Header as="h3">6. Dane użytkowników</Header>
                <br />6.1. Administrator przetwarza dane użytkowników zgodnie z Polityką Prywatności oraz obowiązującymi przepisami o ochronie danych osobowych.
                <br />6.2. Użytkownik ma prawo wglądu w swoje dane, ich poprawiania lub usuwania.


                <Header as="h3">6. Ograniczenie Odpowiedzialności</Header>
                6.1. Dostawca Aplikacji nie ponosi odpowiedzialności za straty wynikające z nieprawidłowego użytkowania Aplikacji.
                <br />6.2. Dostawca Aplikacji gwarantuje ciągłej dostępności Aplikacji na poziomie 99.9% miesiaca, jednak nie ponosi odpowiedzialności za ewentualne przerwy w działaniu systemu.


                <Header as="h3">7. Obowiązki użytkowników</Header>
                7.1. Użytkownik ponosi pełną odpowiedzialność za wszystkie treści związane z utworzonymi turniejami, w tym nazwy turniejów, opisy, grafiki, listy uczestników oraz inne materiały publikowane za pośrednictwem aplikacji.
                <br />7.2. Treści wprowadzane przez użytkownika nie mogą:
                <br />- Naruszać praw osób trzecich, w tym praw autorskich, znaków towarowych czy praw do wizerunku;
                <br />- Zawierać treści niezgodnych z prawem, zniesławiających, obscenicznych, obraźliwych lub w inny sposób naruszających dobre obyczaje.
                <br />7.3. Administrator zastrzega sobie prawo do usunięcia treści, które są sprzeczne z regulaminem, obowiązującym prawem lub które w jakikolwiek sposób mogą naruszać prawa osób trzecich.
                <br />7.4. W przypadku naruszenia powyższych zasad przez użytkownika, wszelkie roszczenia osób trzecich związane z treściami zamieszczonymi przez użytkownika będą kierowane do użytkownika, który zobowiązuje się zwolnić administratora z odpowiedzialności z tego tytułu.


                <Header as="h3">8. Ograniczenie odpowiedzialności</Header>
                8.1. Administrator dostarcza aplikację w modelu „tak jak jest” (ang. as-is). Nie ponosi odpowiedzialności za jakiekolwiek straty wynikające z nieprawidłowego użytkowania aplikacji przez użytkownika.
                <br />8.2. Administrator nie świadczy dodatkowego wsparcia ani usług konsultacyjnych wykraczających poza udostępnienie aplikacji w formie gotowego oprogramowania.



                <Header as="h3">9. Reklamacje i  zwroty</Header>
                9.1. Użytkownik ma prawo zgłaszać reklamacje dotyczące usług świadczonych przez Aplikację.
                <br />9.2. Reklamacja powinna zostać złożona w formie elektronicznej na adres kontaktowy Administratora aplikacji biuro@turniej-generator.pl i zawierać:
                <br /> a. Imię, nazwisko oraz adres e-mail Użytkownika.
                <br /> b. Szczegółowy opis problemu i okoliczności jego wystąpienia.

                <br />9.3. Administrator zobowiązuje się rozpatrzyć reklamację w ciągu 7 dni roboczych. W przypadku niemożności rozpatrzenia reklamacji w tym terminie, użytkownik zostanie poinformowany o przyczynach opóźnienia oraz przewidywanym terminie rozstrzygnięcia sprawy
                <br />9.4. Jeśli reklamacja zostanie uznana za zasadną, administrator podejmie działania w celu rozwiązania problemu.
                <br />9.5. W przypadku reklamacji dotyczącej turniejów utworzonych w płatnych pakietach (Srebrny, Złoty, Diamentowy), jeśli wina leży po stronie administratora, użytkownikowi zostaną zwrócone tokeny wykorzystane na dany turniej.
                <br />9.6. Zwrotów fizycznych nie przewiduje się. Wszystkie zwroty są realizowane wyłącznie w formie tokenów w aplikacji.
                <br />9.7. Administrator nie ponosi odpowiedzialności za problemy techniczne wynikające z winy użytkownika.


                <Header as="h3">8. Zakończenie</Header>
                8.1. Regulamin podlega prawu polskiemu. W przypadku stosunków prawnych z elementem międzynarodowym, strony zgadzają się na stosowanie prawa polskiego, z zachowaniem ochrony konsumenta zgodnie z art. 6 ust. 1 Rozporządzenia Rzym I.
                <br />8.2. Jeżeli którekolwiek postanowienie Regulaminu okaże się nieważne lub nieskuteczne, pozostałe postanowienia pozostają w mocy.
                <br /> 8.3. W przypadku sporu, użytkownik może skorzystać z mediacji lub polubownych metod rozstrzygania sporów przed wniesieniem sprawy do sądu.
                <br /> 8.4. Jeżeli którekolwiek z postanowień Regulaminu jest lub stanie się nieważne lub nieskuteczne, nieważne postanowienie zostanie zastąpione postanowieniem, którego znaczenie jest jak najbardziej zbliżone do postanowienia nieważnego. Nieważność lub bezskuteczność jednego postanowienia nie wpływa na ważność pozostałych postanowień.
                <br />
                <br />{checkiscompanypay() ? "08 Kwiecień 2025r." : "01 Grudzień 2024r."}
              </article>
            </Segment>
          </Container>
        </Grid.Column>


      </Grid.Row>
    </Grid>
  )
}

export default StatueV2;


export function getLimitInfoStatue() {
  return <>
    4.2a. W przypadku organizacji turniejów o większej skali, obowiązuje limit <b>{Number(process.env.REACT_APP_IN_LIMITALLMEMBERS)} uczestników</b> (zawodników lub drużyn) przypadających na jedno wydarzenie sportowe, rozumiane jako turniej lub powiązane rozgrywki odbywające się np. w tej samej lokalizacji w ramach np. trzech dni kalendarzowych.

    <br />- Po przekroczeniu tego limitu, za każdego dodatkowego uczestnika naliczana jest dopłata zgodnie z poniższym zestawieniem:

    {FeeTable()}

    - Ostateczna interpretacja, czy dane turnieje lub rozgrywki stanowią jedno wydarzenie sportowe, należy do administratora systemu.

    <br />- Każda próba obejścia tego limitu poprzez tworzenie kilku mniejszych turniejów lub inne działania mające na celu uniknięcie opłat, zostanie automatycznie wykryta przez system.

    <br />- W przypadku naruszenia niniejszego punktu, administrator systemu ma prawo tymczasowo zablokować konto użytkownika do czasu wyjaśnienia sytuacji oraz naliczyć opłatę na podstawie łącznej liczby uczestników z przekroczonego limitu.
  </>
}

export function FeeTable() {
  return <><Table celled compact size='mini'>
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell>Zakres uczestników</Table.HeaderCell>
        <Table.HeaderCell>Stawka netto za uczestnika</Table.HeaderCell>
      </Table.Row>
    </Table.Header>

    <Table.Body>
      <Table.Row>
        <Table.Cell>201–550</Table.Cell>
        <Table.Cell>0,80 zł</Table.Cell>
      </Table.Row>
      <Table.Row>
        <Table.Cell>551–700</Table.Cell>
        <Table.Cell>0,70 zł</Table.Cell>
      </Table.Row>
      <Table.Row>
        <Table.Cell>701–850</Table.Cell>
        <Table.Cell>0,60 zł</Table.Cell>
      </Table.Row>
      <Table.Row>
        <Table.Cell>851–1000</Table.Cell>
        <Table.Cell>0,50 zł</Table.Cell>
      </Table.Row>
      <Table.Row>
        <Table.Cell>1001–1150</Table.Cell>
        <Table.Cell>0,40 zł</Table.Cell>
      </Table.Row>
      <Table.Row>
        <Table.Cell>1151–1500</Table.Cell>
        <Table.Cell>0,30 zł</Table.Cell>
      </Table.Row>
      <Table.Row>
        <Table.Cell>1501+</Table.Cell>
        <Table.Cell>0,20 zł</Table.Cell>
      </Table.Row>
    </Table.Body>
    <Table.Footer>
      <Table.Row>
        <Table.HeaderCell colSpan='2' style={{fontWeight:"bold",fontSize:13}}> Dopłaty są naliczane warstwowo – np. przy 630 uczestnikach: 350 osób × 0,80 zł + 80 osób × 0,70 zł
          <br/>
          <p><strong>Uwaga:</strong> jeśli dany uczestnik bierze udział w więcej niż jednej kategorii, system <strong>zlicza każde uczestnictwo osobno</strong>.
          <br/> Przykład: jeśli w kategorii A zgłoszono 315 osób, a w kategorii B również 315 osób, przy czym część zawodników występuje w obu kategoriach, opłata zostanie naliczona za <strong>430 uczestnictw (ponad limit)</strong>, a nie za unikalnych zawodników.</p>
        </Table.HeaderCell>

      </Table.Row>
    </Table.Footer>
  </Table>

  </>
}
